import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  // No focus ring here: index.css owns a single global :focus-visible outline.
  // active:translate-y-px gives every button a press response — there was none.
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-[background-color,color,box-shadow,transform] duration-150 active:translate-y-px disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow-sm hover:bg-primary-hover active:bg-primary-active",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 active:bg-destructive/95",
        outline:
          "border border-border-strong bg-card shadow-xs hover:bg-primary-subtle hover:border-primary/30 hover:text-primary active:bg-accent",
        secondary:
          "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80 active:bg-secondary/90",
        ghost: "hover:bg-primary-subtle hover:text-primary active:bg-accent",
        link: "text-primary underline-offset-4 hover:underline active:translate-y-0",
      },
      size: {
        // Phones get a larger tap target; `sm:` restores the tighter desktop sizes.
        default: "h-10 sm:h-9 px-4 py-2",
        sm: "h-9 sm:h-8 rounded-md px-3 text-xs",
        lg: "h-11 sm:h-10 rounded-md px-8",
        icon: "h-10 w-10 sm:h-9 sm:w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
